import * as React from "react";
import {Box, Typography} from "@mui/material";
import {useDroppable} from "@dnd-kit/core";
import {styles} from "./LeadPipelineStyles";

export default function LeadPipelineColumn({stage, title, caption, leadsCount, acceptsDrop, children}) {
    const style = styles();
    const {setNodeRef, isOver} = useDroppable({id: stage, disabled: !acceptsDrop});
    const columnStyle = {
        ...style.column,
        ...(acceptsDrop ? style.columnAcceptingDrop : {}),
        ...(acceptsDrop && isOver ? style.columnHighlightedForDrop : {}),
    };

    return (
        <Box ref={setNodeRef} sx={columnStyle}>
            <Box sx={style.columnHeader}>
                <Typography sx={style.columnTitle}>{title}</Typography>
                <Typography sx={style.columnCount}>{leadsCount}</Typography>
            </Box>
            {caption && <Typography sx={style.columnCaption}>{caption}</Typography>}
            {leadsCount === 0 ? <Typography sx={style.emptyColumn}>Sin casos</Typography> : children}
        </Box>
    );
}
